var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_Assignments",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Planner_Checklist",
    "data-name": "Planner Checklist"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 20,
    height: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(1.667 2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    d: "M0,0H16.667V5A4.167,4.167,0,0,1,12.5,9.167H4.167A4.167,4.167,0,0,1,0,5Z",
    transform: "translate(0 6.667)",
    fill: "none",
    stroke: "#1891e5",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M1.667,0H15a1.667,1.667,0,0,1,1.667,1.667V5H0V1.667A1.667,1.667,0,0,1,1.667,0Z",
    transform: "translate(0 1.667)",
    fill: "none",
    stroke: "#1891e5",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M.833,0V2.5",
    transform: "translate(12.5)",
    fill: "none",
    stroke: "#1891e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M.833,0V2.5",
    transform: "translate(3.333)",
    fill: "none",
    stroke: "#1891e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9aee293e.svg";
export { ForwardRef as ReactComponent };